/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespIconBubbles_viewer = {
    readonly shareJewelryItemTooltip?: boolean | null | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedIconBubbleEmail_viewer">;
    readonly " $refType": "PdpRespIconBubbles_viewer";
};
export type PdpRespIconBubbles_viewer$data = PdpRespIconBubbles_viewer;
export type PdpRespIconBubbles_viewer$key = {
    readonly " $data"?: PdpRespIconBubbles_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespIconBubbles_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbles_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleEmail_viewer"
    },
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "shareJewelryItemTooltip",
          "args": [
            {
              "kind": "Literal",
              "name": "feature",
              "value": "shareJewelryItemTooltip"
            }
          ],
          "kind": "ScalarField",
          "name": "featureFlag",
          "storageKey": "featureFlag(feature:\"shareJewelryItemTooltip\")"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '5dc990bbd271519b2ed6211c9ec71831';
export default node;
